import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { IconName } from '../../icons/types';

type UseInputPasswordParams = {
  hasVisibilityToggle: boolean;
  iconAriaLabel?: string;
};

type InputPasswordToggleProps = {
  type: string;
  icon?: IconName;
  iconAriaLabel?: string;
  onClickIcon?: () => void;
};

function useInputPassword({ hasVisibilityToggle, iconAriaLabel }: UseInputPasswordParams): InputPasswordToggleProps {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  function onToggleVisibility() {
    setIsVisible((prev) => !prev);
  }

  if (!hasVisibilityToggle) {
    return { type: 'password' };
  }

  const toggleIcon: IconName = isVisible ? 'visible' : 'visible-off';

  // aria-label based on the button's ACTION (not the icon): when the password
  // is hidden the action is "show"; when it is visible the action is "hide".
  const resolvedIconAriaLabel = iconAriaLabel ?? (isVisible ? t('buttons:Hide password') : t('buttons:Show password'));

  return {
    type: isVisible ? 'text' : 'password',
    icon: toggleIcon,
    iconAriaLabel: resolvedIconAriaLabel,
    onClickIcon: onToggleVisibility,
  };
}

export default useInputPassword;
